@if (!inline()) {
<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{'SIGNATURE' | translation}}</h5>
  </div>
  <div #body class="modal-body p-0">
    <ng-container [ngTemplateOutlet]="canvasTemplate"></ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="success($event)">{{'OK' | translation}}</button>
  </div>
</div>
} @else {
<div class="standalone-signature">
  <ng-container [ngTemplateOutlet]="canvasTemplate"></ng-container>
</div>
}

<ng-template #canvasTemplate>
  <div #body class="signature-body">
    <canvas #canvas (endStroke)="stoppedDrawing($event)" [width]="body.offsetWidth"
      [height]="body.offsetHeight"></canvas>
  </div>
</ng-template>
